enum PricingCalculationArgs {
  'pricingCalculationArgs.vehicle.vehicleModel.vehicleClasses' = 'pricingCalculationArgs.vehicle.vehicleModel.vehicleClasses',
  'pricingCalculationArgs.vehicle.year' = 'pricingCalculationArgs.vehicle.year',
  'pricingCalculationArgs.vehicle.makeCode' = 'pricingCalculationArgs.vehicle.makeCode',
  'pricingCalculationArgs.vehicle.model' = 'pricingCalculationArgs.vehicle.model',
  'pricingCalculationArgs.vehicle.engineType' = 'pricingCalculationArgs.vehicle.engineType',
  'pricingCalculationArgs.vehicle.fuelType' = 'pricingCalculationArgs.vehicle.fuelType',
}
export default PricingCalculationArgs;
